module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "paraspaceabovebm"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("It seems so idyllic.")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("An insidiously calm, dew-damp morning. The rays of the sun slowly but relentlessly take possession of the art nouveau building’s clean plaster façade, triumphantly embracing it with their indifferent heat and giving it a sheen the night had hidden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As if nothing had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As if this summer morning heralded a day like any other. A day full of life: sweaty bodies on bicycles; suppressed giggles in front of the ice cream stand by the harbor; steaming, sunburned shoulders; clumsy summer sex as light-blue twilight seamlessly turns to daybreak; the nauseating smell of white wine and lemonade in the pine needle–carpeted edge of the forest north of the pizzeria; the cold water of the lake against skinny child bodies with ribs that seem ready to burst out of their cages, through the soft, paper-thin, milk-white skin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gawky teenage boys swim races to the island and back, outlined like pale frog people, amphibious sailing vessels, against the water’s saturated blue-brown darkness. They howl as they jump off the rock. The air is filled with the aroma of grilled meat and the sound of distant motorboats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mosquitoes. Wasps. Insects with no name: in your hair, in your mouth, on bodies, itchy, sweaty bodies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Swedish as it gets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A summer without end.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As if nothing had happened.")]), _vm._v(" "), _c('p', {
    staticClass: "centera"
  }, [_vm._v("•  •  •")])]), _c('p', {
    staticClass: "paraspaceabovebm"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Even the building appears indifferent. Heavy and listless, it sits in the lush garden, bedded in leafy, dew-covered greenery. Its massive three-story-high body reaches toward the blue of the brightening summer sky. ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("The plaster has not flaked in a single spot. The gray-green paint that covers the windowsills and doors is fresh and still glossy. There are no cracks or dust in the leaded, stained windowpanes with their coiling organic flower patterns. The roof is covered with old emerald-green copper plate, the kind roofers no longer use.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It seems so idyllic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But something is out of place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the neatly raked gravel parking area is a dazzlingly clean black Jeep. The paint of the Jeep reflects a clematis with large pure white blossoms climbing up a knotted old apple tree. Someone is lying under the low trunk and crooked branches of the tree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A young woman, a girl.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She is curled up in the grass like a bird, her red hair covered by a thin film of dew. Her slender, pale arms are thrown out along her sides, her palms turned upward in a gesture of resignation. The blood that has seeped from her body is congealed in reddish-brown patches on her jeans and in the grass. Her open eyes seem to be inspecting the crown of the apple tree.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Up there, in the branches, there are small green apples. There are many: The tree will bear plenty of fruit in just a few months. Above the apple tree the swifts and gulls fly unaffected—what do they care about a dead human child?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Under the body, the smallest inhabitants of the garden have already discovered what no person has yet seen. A small black beetle creeps between the waistband and the cold, pale skin in search of something edible; flies have set up camp in the lush red forest of hair; and microscopic creatures are moving slowly but steadily deeper and deeper into the windings of the ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a little while, the inhabitants of the house will wake up and look for the girl. When they don’t find her, they will search for her in the garden, where they will see her in the grass under the tree, her eyes gazing toward the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They will shake her as if trying to wake her from a deep sleep, and when that doesn’t work, one of them will slap her hard across the cheek, staining her face red with her own uncoagulated blood on his hand.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("They will take her in their arms and slowly rock her back and forth. One of them will whisper something in her ear, while the other one buries his face in her hair.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "centera"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabovebm"
  }, [_vm._v("Later, the men who never knew her, who don’t even know her name, will come to get her. They will put their calloused hands around her slender, rigid wrists and ankles and lift her effortlessly onto a cold stretcher, cover her with plastic, and drive her far, far from home.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She will be placed on a metal table, alongside the surgical instruments that will open her up and—hopefully—solve the mystery, explain the unexplainable, restore balance. Bring clarity to something no one understands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Create closure and perhaps peace as well.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Some kind of peace.")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 81
// module chunks = 0